module.exports = __webpack_public_path__ + "static/img/Free Fire.7fa40893.png";